import { render } from "./salesPage.vue?vue&type=template&id=0c318141"
import script from "./salesPage.vue?vue&type=script&lang=js"
export * from "./salesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__